import { cva } from 'class-variance-authority'

export const tagRootVariant = cva('mr-0 rounded px-2', {
  variants: {
    color: {
      primary: 'border-primary bg-primary text-white',
      secondary: 'border-secondary bg-secondary text-white',
      info: 'border-info bg-info text-white',
      'blue-5': 'border-blue-5 bg-blue-5 text-white',
      green: 'border-green bg-green text-white',
      yellow: 'border-yellow bg-yellow text-white',
      red: 'border-red bg-red text-white',
      'orange-5': 'border-orange-5 bg-orange-5 text-white',
      'orange-6': 'border-orange-6 bg-orange-6 text-white',
      'gray-1': 'border-gray-1 bg-gray-1 text-white',
      'gray-2': 'border-gray-2 bg-gray-2 text-white',
      pink: 'border-pink-300 bg-pink-300 text-white',
      // default と light系は Antd 側の配色を使う
      default: '',
      'light-blue': '',
      'light-red': '',
      'light-green': ''
    },
    size: {
      default: '!h-auto py-1 leading-none',
      small: 'py-[3px] text-2xs leading-none'
    }
  }
})
